module.exports = __webpack_public_path__ + "static/img/h1-2.ddd3d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h1-2.png
// module id = bsDr
// module chunks = 1